// frontend/src/components/layout/AdminLayout.js
import React, { useState } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
// İKONLAR (FaChartLine eklendi)
import { 
  FaHome, FaUsers, FaCreditCard, FaListAlt, FaSignOutAlt, 
  FaEnvelope, FaBullhorn, FaBell, FaBars, FaTimes, FaUserTie,
  FaChartLine, 
  FaStackExchange,
  FaUserCog
} from 'react-icons/fa';

const AdminLayout = () => {
  const { logout, userInfo } = useAuth();
  const navigate = useNavigate();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { path: '/admin/dashboard', name: 'Genel Bakış', icon: <FaHome /> },
    { path: '/admin/apps', name: 'Abonelikler', icon: <FaListAlt /> }, 
    { path: '/admin/activity', name: 'Aktivite & Loglar', icon: <FaChartLine /> },
    { path: '/admin/notifications', name: 'Bildirimler', icon: <FaBell /> },
    { path: '/admin/announcements', name: 'Duyurular', icon: <FaBullhorn /> },
    { path: '/admin/dashboard-settings', name: 'K. Paneli Ayarları', icon: <FaUserCog /> }, // <-- YENİ MENÜ LİNKİ
    { path: '/admin/mail-settings', name: 'Mail Ayarları', icon: <FaEnvelope /> },
    { path: '/admin/payments', name: 'Ödemeler', icon: <FaCreditCard /> },
    { path: '/admin/members', name: 'Üye Yönetimi', icon: <FaUsers /> },
  ];

  const adminAvatar = userInfo?.avatar || '/avatar/default-avatar.png';

  return (
    <div className="flex h-screen bg-background text-text-primary overflow-hidden relative">
      
      {/* MOBİL OVERLAY */}
      {isMobileMenuOpen && (
        <div 
          className="fixed inset-0 bg-black/50 z-40 md:hidden backdrop-blur-sm"
          onClick={() => setIsMobileMenuOpen(false)}
        ></div>
      )}

      {/* SIDEBAR */}
      <aside 
        className={`
          fixed md:relative z-50 h-full w-64 bg-surface border-r border-border flex flex-col transition-transform duration-300 ease-in-out
          ${isMobileMenuOpen ? 'translate-x-0' : '-translate-x-full md:translate-x-0'}
        `}
      >
        <div className="h-20 flex items-center justify-between px-6 border-b border-border">
           <h2 className="text-2xl font-bold bg-gradient-to-r from-primary to-blue-400 bg-clip-text text-transparent">
             PAYDA <span className="text-xs text-text-secondary font-mono">ADMIN</span>
           </h2>
           <button onClick={() => setIsMobileMenuOpen(false)} className="md:hidden text-gray-400 hover:text-white transition-colors">
             <FaTimes size={24} />
           </button>
        </div>

        <nav className="flex-1 py-6 px-4 space-y-2 overflow-y-auto custom-scrollbar">
          {menuItems.map((item) => (
            <NavLink
              key={item.path}
              to={item.path}
              onClick={() => setIsMobileMenuOpen(false)}
              className={({ isActive }) =>
                `flex items-center px-4 py-3 rounded-xl transition-all duration-200 group ${
                  isActive 
                  ? 'bg-primary text-white shadow-lg shadow-primary/30' 
                  : 'text-text-secondary hover:bg-gray-800 hover:text-white'
                }`
              }
            >
              <span className="text-xl mr-3">{item.icon}</span>
              <span className="font-medium">{item.name}</span>
            </NavLink>
          ))}
          
          <div className="pt-4 mt-2 border-t border-gray-700">
             <NavLink
              to="/user/dashboard"
              onClick={() => setIsMobileMenuOpen(false)}
              className="flex items-center px-4 py-3 rounded-xl transition-all duration-200 text-blue-400 hover:bg-blue-500/10 hover:text-blue-300"
            >
              <span className="text-xl mr-3"><FaUserTie /></span>
              <span className="font-medium">Kullanıcı Paneli</span>
            </NavLink>
          </div>

        </nav>

        <div className="p-4 border-t border-border mt-auto bg-surface">
          <div className="flex items-center gap-3 mb-4 px-2">
             <img 
                src={adminAvatar} 
                alt="Admin" 
                className="w-10 h-10 rounded-full object-cover border border-gray-600"
             />
             <div className="overflow-hidden">
                <p className="text-sm font-bold text-white truncate">{userInfo?.name}</p>
                <p className="text-xs text-text-secondary">Yönetici</p>
             </div>
          </div>
          <button 
            onClick={handleLogout} 
            className="w-full flex items-center justify-center gap-2 bg-red-500/10 text-red-500 hover:bg-red-500 hover:text-white py-2 rounded-lg transition-colors text-sm font-bold"
          >
            <FaSignOutAlt /> Çıkış Yap
          </button>
        </div>
      </aside>

      {/* MAIN CONTENT */}
      <main className="flex-1 flex flex-col min-w-0 overflow-hidden relative w-full">
        <header className="md:hidden h-16 bg-surface border-b border-border flex items-center justify-between px-4 sticky top-0 z-30 shadow-md">
            <div className="flex items-center gap-3">
              <button onClick={() => setIsMobileMenuOpen(true)} className="text-text-secondary hover:text-white p-2 rounded-lg hover:bg-gray-800 transition-colors">
                <FaBars size={20} />
              </button>
              <span className="font-bold text-lg text-white">Admin Panel</span>
            </div>
        </header>

        <div className="flex-1 overflow-auto p-4 md:p-8 relative custom-scrollbar">
           <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none fixed">
                <div className="absolute top-[-10%] right-[-5%] w-96 h-96 bg-primary/5 rounded-full blur-3xl"></div>
                <div className="absolute bottom-[-10%] left-[-10%] w-72 h-72 bg-purple-500/5 rounded-full blur-3xl"></div>
           </div>
           <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AdminLayout;